import React from 'react';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';

import './RewardPointModal.less';


export class RewardPointModal extends CommonComponent {
  constructor(props) {
    super(props);

    this.state = {
      rewardPointObj: {
        showModal: false,
        count: '',
        callback: ''
      }, 
      collectGiftsObj: {
        showModal: false,
        gifts: '',
        callback: ''
      },
      collectGetObj: {
        showModal: false,
        gifts: '',
        callback: ''
      },
      shareGiftsObj: {
        showRewardsModal: false,
        showExtraRewardModal: false,
        gifts: '',
        immediately: '',
        callback: ''
      },
      cdnUrl: app.getCdnUrl(),
      topNavBarHeight: 0
    }
  }

  componentDidMount(){
  }

  show = (options) => {
    if(options.rewardPointObj){
      this.setState({
        rewardPointObj: options.rewardPointObj
      })
    }
    if(options.shareGiftsObj){
      this.setState({
        shareGiftsObj: options.shareGiftsObj
      })
    }
    if(options.collectGiftsObj){
      if (options.collectGiftsObj && options.collectGiftsObj.showModal){
        let pageInstance = app.getAppCurrentPage();
        if (pageInstance.data.page_hasNavBar) {
          this.setState({
            topNavBarHeight: app.globalData.topNavBarHeight
          })
        }
      }
      this.setState({
        collectGiftsObj: options.collectGiftsObj
      })
    }
    if(options.collectGetObj){
      this.setState({
        collectGetObj: options.collectGetObj
      })
    }
  }

  stopPropagation = (e) => {
    e.stopPropagation();
  }

  closeModal = () => {
    this.setData({
      'rewardPointObj.showModal': false,
    });
    app.rewardPointCB(this.data.rewardPointObj.callback);
  }

  closeShareModal = () => {
    this.setData({
      'shareGiftsObj.showRewardsModal': false
    })
  }

  closeExtraGifts = () => {
    this.setData({
      'shareGiftsObj.showExtraRewardModal': false
    })
  }

  toshareGifts = () => {
    let shareGiftsObj = this.data.shareGiftsObj;
    this.setData({
      'rewardPointObj.showModal': false,
      'shareGiftsObj.showRewardsModal': false
    });
    app.turnToPage('/eCommerce/pages/shareGifts/shareGifts?ids=' + shareGiftsObj.gifts.appoint_ids + '&extraIds=' + shareGiftsObj.gifts.extra_appoint_ids);
  }

  toShowGifts = (e) => {
    let that = this,
        type = that.data.shareGiftsObj.extra_rewards[0].type,
        path;
    switch (type) {
      case '1':
        path = '/eCommerce/pages/couponList/couponList';
        break;
      case '2':
        path = '/userCenter/pages/myIntegral/myIntegral';
        break;
      case '3':
        path = '/eCommerce/pages/balance/balance';
        break;
      case '4':
        path = '/userCenter/pages/vipCardList/vipCardList';
        break;
      case '5':
        path = '/eCommerce/pages/vipBenefits/vipBenefits?id=' + that.data.shareGiftsObj.extra_rewards[0].value;
        break;
      case '6':
        path = '/awardManagement/pages/collectStars/collectStars';
        break;
      case '7':
        path = '/awardManagement/pages/luckyWheelDetail/luckyWheelDetail';
        break;
      case '8':
        path = '/awardManagement/pages/scratch/scratch';
        break;
      case '9':
        path = '/awardManagement/pages/goldenEggs/goldenEggs';
        break;
    }
    this.setData({
      'rewardPointObj.showModal': false,
      'shareGiftsObj.showExtraRewardModal': false
    });
    app.turnToPage(path)
  }

  toCollectGifts = (e) => {
    let data = e.currentTarget.dataset,
      type = data.type,
      path;
    switch (type) {
      case '1':
        path = '/eCommerce/pages/couponList/couponList';
        break;
      case '2':
        path = '/userCenter/pages/myIntegral/myIntegral';
        break;
      case '3':
        path = '/eCommerce/pages/balance/balance';
        break;
      case '4':
        path = '/userCenter/pages/vipCardList/vipCardList';
        break;
      case '5':
        path = '/eCommerce/pages/vipBenefits/vipBenefits';
        break;
      case '6':
        path = '/awardManagement/pages/collectStars/collectStars';
        break;
      case '7':
        path = '/awardManagement/pages/luckyWheelDetail/luckyWheelDetail';
        break;
      case '8':
        path = '/awardManagement/pages/scratch/scratch';
        break;
      case '9':
        path = '/awardManagement/pages/goldenEggs/goldenEggs';
        break;
    }
    this.setData({
      'rewardPointObj.showModal': false,
      'shareGiftsObj.showExtraRewardModal': false
    });
    app.turnToPage(path)
  }

  closeGiftsModal = () => {
    this.setData({
      'collectGiftsObj.showModal': false
    });
  }

  closeGetModal = () => {
    this.setData({
      'collectGetObj.showModal': false
    })
  }


  render(){
    let { 
      rewardPointObj,
      cdnUrl,
      shareGiftsObj,
      topNavBarHeight,
      collectGiftsObj,
      collectGetObj
    } = this.state;

    return (
      <React.Fragment>
        {
          rewardPointObj.showModal && 
          (
            <div className="common-component rewardPointModal-wrap" onTouchMove={(e) => this.stopPropagation(e)} style={{zIndex:11}}>
              <div className="rewardPointModal-win">
                <div className="rewardPointModal-bg" style={{backgroundImage: 'url('+cdnUrl+'/static/webapp/images/reward_bg.png),url('+cdnUrl+'/static/webapp/images/reward_coin.png);'}}><label onClick="closeModal" className="ico-moon icon-closes rewardPointModal-closes"></label></div>
                <div className="rewardPointModal-text">
                  <div className="rewardPointModal-p1">恭喜你</div>
                  <div className="rewardPointModal-p2">获得<span className="rewardPointModal-rewardCount">{rewardPointObj.count}积分</span></div>
                </div>
                <button className="rewardPointModal-button" onClick="closeModal">知道了</button>
              </div>
            </div>
          )
        }

        {
          shareGiftsObj.showRewardsModal && shareGiftsObj.gifts.rewards.length > 0 && 
          (
            <div className="common-component rewardPointModal-wrap" onTouchMove={(e) => this.stopPropagation(e)} style={{zIndex:12}}>
              <div className="share-gifts-wrap share-reward-wrap">
                <div className="share-main-wrap">
                  <div className="share-top-wrap">
                    <img className="image-wrap" src='http://cdn.jisuapp.cn/static/webapp/images/share-gifts/popup-top.png' />
                  </div>
                  <div className="share-content-wrap">
                    <div className="share-tips">分享有礼</div>
                    <div className="share-method">
                      {(shareGiftsObj.gifts.recv_limit == 0  || shareGiftsObj.gifts.rewards.length == 1) && <div>恭喜你获得以下奖励</div>}
                      {shareGiftsObj.gifts.recv_limit == 1 && <div>
                        {shareGiftsObj.gifts.recv_chance == 0 ? '奖励领取成功' : !(shareGiftsObj.gifts.recv_chance > 1 && shareGiftsObj.gifts.recv_limit == 1 && shareGiftsObj.gifts.rewards.length > 1) ? '以下奖励选一个' : '以下奖励可选'}
                      </div>}
                      <div className="share-method-list">
                        {
                          shareGiftsObj.gifts && shareGiftsObj.gifts.rewards && shareGiftsObj.gifts.rewards.map((item, index) => (
                              item.stock != 0 && (<div className="list-item" key={index} style={{width:'80%', margin:'0 auto', wordBreak:'break-all'}}>
                                {item.type == 1 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/coupon.png" />}
                                {item.type == 2 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/integral.png" />}
                                {item.type == 3 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/balance.png" />}
                                {(item.type == 4 || item.type == 5) && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/vip-card.png" />}
                                {item.type == 6 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/collect.png" />}
                                {item.type == 7 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/lucky-wheel.png" />}
                                {item.type == 8 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/scratch.png" />}
                                {item.type == 9 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/golden.png" />}
                                <span className="list-item-text">{item.title}</span>
                              </div>)
                          ))
                        }
                      </div>
                    </div>
                    {
                      (shareGiftsObj.gifts.rewards.length <= 1 || shareGiftsObj.gifts.recv_limit == 0) ? <div className="share-btn" onClick={this.toshareGifts} data-type={shareGiftsObj.gifts.rewards[0].type}>点击前往查看</div> : <div className="share-btn" onClick={this.toshareGifts}>点击前往领取</div>
                    }              
                  </div>
                </div>
                <div className="ico-moon icon-closed share-gifts-closes" onClick={this.closeShareModal}>
                </div>
              </div>
            </div>
          )
        }

        {
          (shareGiftsObj.showExtraRewardModal && shareGiftsObj.extra_rewards.length > 0 && (shareGiftsObj.immediately == 1 || shareGiftsObj.gifts.rewards.length == 0)) && 
          (
            <div className="common-component rewardPointModal-wrap" onTouchMove={(e) => this.stopPropagation(e)} style={{zIndex:11}}>
              <div className="share-gifts-wrap share-extraReward-wrap">
                <div className="share-main-wrap">
                  <div className="share-top-wrap">
                    <img className="image-wrap" src='http://cdn.jisuapp.cn/static/webapp/images/share-gifts/popup-top.png' />
                  </div>
                  <div className="share-content-wrap">
                    <div className="share-tips">拉新成功</div>
                    <div className="share-method">
                      <div className="share-new_comer">拉新成功：【<span className="new-comer-nickname">{shareGiftsObj.extra_rewards[0].new_comer}</span>{shareGiftsObj.extra_rewards[0].num > 1 ? '等' : ''}</div>
                      <div className="extra-text">恭喜你获得以下奖励</div>
                      <div className="share-method-list">
                        {
                          shareGiftsObj.extra_rewards && shareGiftsObj.extra_rewards.map((item, index) => (
                            <div className="list-item" key={index} style={{width: '80%', margin: '0 auto', wordBreak: 'break-all'}}>
                              {shareGiftsObj.extra_rewards[0].type == 1 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/coupon.png" />}
                              {shareGiftsObj.extra_rewards[0].type == 2 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/integral.png" />}
                              {shareGiftsObj.extra_rewards[0].type == 3 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/balance.png" />}
                              {(shareGiftsObj.extra_rewards[0].type == 4 || shareGiftsObj.extra_rewards[0].type == 5) && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/vip-card.png" />}
                              {shareGiftsObj.extra_rewards[0].type == 6 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/collect.png" />}
                              {shareGiftsObj.extra_rewards[0].type == 7 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/lucky-wheel.png" />}
                              {shareGiftsObj.extra_rewards[0].type == 8 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/scratch.png" />}
                              {shareGiftsObj.extra_rewards[0].type == 9 && <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/golden.png" />}
                              <span className="list-item-text">{item.reward_title} {item.num > 1 ? '*' + item.num : ''}</span>
                            </div>
                          ))
                        }
                      </div>
                    </div>
                    <div className="share-btn" onClick={this.toShowGifts}>点击前往查看</div>
                  </div>
                </div>
                <div className="ico-moon icon-closed share-gifts-closes" onClick={this.closeExtraGifts}>
                </div>
              </div>
            </div>
          )
        }
    
        {
          collectGiftsObj.showModal && 
          (
            <div className="common-component rewardPointModal-wrap" onTouchMove={(e) => this.stopPropagation(e)} style={collectGiftsObj.style.type == 1 || collectGiftsObj.style.type == 2 ? {zIndex: 15, top: topNavBarHeight + 'px', background: 'rgba(0,0,0,.70)'} : {zIndex: 15, top: topNavBarHeight + 'px', height:'4.5rem', background: 'rgba(255,255,255,0)'}}>
              {
                collectGiftsObj.style.type == 1 && 
                <div className="collect-gifts-wrap type1">
                  <div className="type1-arrow"></div>
                  <div className="collect-step">
                    <div className="type1-collect"></div>
                    <div className="section-tips">
                      <div className="tips-text"  style={{color:'#ff7100'}}>
                        点击
                        <img className="bottom-line" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/bottom-line.png" />
                      </div>
                      这里，选择添加到我的小程序
                    </div>
                  </div>
                  <img className="section-logo" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/section-arrow.png" />
                  <div className="collect-step">
                    <div className="type1-customer"> </div>
                    <div className="section-tips">
                      微信
                      <div className="tips-text" style={{color:'#ff7100'}}>
                        下拉
                        <image className="bottom-line" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/bottom-line.png" />
                      </div>
                      ，从【我的小程序】进入店铺
                    </div>
                  </div>
                  <img className="section-logo" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/section-arrow.png" />
                  <div className="method-wrap">
                    <div className="method-list method-list-show" style={{position:'absolute'}}>
                      {
                        collectGiftsObj.gifts && collectGiftsObj.gifts.map((item, index) => (
                          <div className="method-item-list" key={index}>
                            <div className="method-item">
                              <img className="image" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/hook.png" />
                              <div className="title">{item.title}</div>
                            </div>
                          </div>
                        ))
                      }
                    </div>
                    <div style={{height: (0.5 * collectGiftsObj.gifts.length) + 'rem',marginBottom:'.5rem'}}></div>
                    <div className="section-tips" style={{fontSize:'.3rem'}}>完成后，将获得以上
                      <div className="tips-text" style={{color:'#ff7100'}}>
                        奖励
                        <img className="bottom-line" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/bottom-line.png" />
                      </div>
                    </div>
                    <div className="collect-gifts-closes" onClick={this.closeGiftsModal}>{collectGiftsObj.manualClose.value}</div>
                  </div>
                </div>
              }
              {
                collectGiftsObj.style.type == 2 && 
                <div className="collect-gifts-wrap type2">
                  <div className="main-wrap">
                    <div className="collect-step">
                      <div className="image-wrap step-item">
                        1. 点击右上角
                        <img className="image"src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast2/share.png" style={{marginLeft:'.1rem'}} />
                        按钮
                      </div>
                    </div>
                    <div className="collect-step">
                      <div className="step-item">2. 点击“添加到我的小程序”</div>
                    </div>
                    <div className="collect-step">
                      <div className="step-item">3. 在微信首页下拉打开任务栏，从“我的小程序”进入店铺。</div>
                    </div>
                    <div className="method-wrap">
                      <div className="image-wrap">
                        <img src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast2/block.png" style={{width:'.26rem', height:'.18rem', marginRight: '12rpx'}} />
                        完成以上步骤你将获得以下奖励
                      </div>
                      <div className="method-list">
                        {
                          collectGiftsObj.gifts && collectGiftsObj.gifts.map((item, index) => (
                            <div className="method-item image-wrap" key={index}>
                              <img className="image" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast2/hook.png" style={{height:'.26rem',width:'.32rem',marginRight:'.17rem'}} />
                              <div className="title">{item.title}</div>
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  </div>
                  <label onClick={this.closeGiftsModal} className="ico-moon icon-closes rewardPointModal-closes"></label>
                </div>
              }
              {
                collectGiftsObj.style.type == 3 && 
                <div className={`collect-gifts-wrap type3 mode${collectGiftsObj.style.default}`} style={{background: collectGiftsObj.style.bg}}>
                  <div>
                    <div className="main-wrap" style={{color: collectGiftsObj.style.text}}>
                      <div className="header-tips">
                        <div className="logo-tips" style={{color: collectGiftsObj.style.main}}>
                          <label className="ico-moon icon-collect-rect-left collect-rect" style={{marginRight:'-.06rem'}}></label>
                          <label className="ico-moon icon-collect-rect-right collect-rect" style={{opacity:0.2}}></label>
                        </div>
                        <span style={{opacity: 0.8}}>完成以下步骤有奖励</span>
                      </div>
                      <div className="collect-step">
                        <div className="image-wrap step-item">
                          <span className="step ico-moon icon-collect-first"></span>
                          点击这里
                          <img src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast2/share.png" onClick={this.closeGiftsModal} style={{width:'.87rem',height:'.48rem',margin:'0 0.07rem'}} />
                          选择添加到我的小程序
                        </div>
                      </div>
                      <div className="collect-step">
                        <div>
                          <span className="step ico-moon icon-collect-second"></span>
                          微信下拉，从“我的小程序”进入店铺
                        </div>
                      </div>
                      <div className="method-wrap">
                        <div className="gifts-logo">
                          <span className="rewards-tips" style={{opacity:0.8}}>奖励</span>
                          <label className="ico-moon icon-collect-line" style={{color: collectGiftsObj.style.main}}></label>
                        </div>
                        <div className="gifts-list">
                          {
                            collectGiftsObj.gifts && collectGiftsObj.gifts.map((item, index) => (
                              <React.Fragment>
                              { index == collectGiftsObj.gifts.length - 1 ? item.title : item.title + '、' }
                              </React.Fragment>
                            ))
                          }
                        </div>
                      </div>
                    </div>
                    <label onClick={this.closeGiftsModal} className="ico-moon icon-collect-close rewardPointModal-closes" style={{color: collectGiftsObj.style.btn}}></label>
                  </div>
                  <div className="arrow-logo-wrap">
                    <div className="arrow-logo" style={{background: collectGiftsObj.style.bg}}>
                    </div>
                  </div>
                </div>
              }
            </div>
          )
        }
      
        {
          collectGetObj.showModal && 
          (
            <div className="common-component rewardPointModal-wrap" onTouchMove={(e) => this.stopPropagation(e)} style={{zIndex:15, background:'rgba(0,0,0,.7)'}}>
              <div className="collect-get-main-wrap">
                <div className="image-wrap">
                  <img className="image"  src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast-gifts/star.png" />
                </div>
                <div>
                  <div className="header-tips">欢迎回来 恭喜你获得以下奖励</div>
                  <div className="method-list">
                    {
                      collectGetObj.gifts && collectGetObj.gifts.map((item, index) => (
                        <div key={index} className="method-item">
                          <div className="methods">
                            <div className="meth">
                              {
                                item.type == 1 && 
                                <div className="gifts-logo" style={{background:'rgba(255, 129, 45, .1)'}}>
                                  <image className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/coupon.png" />
                                </div>
                              }
                              {
                                item.type == 2 && 
                                <div className="gifts-logo" style={{background:'rgba(244, 90, 97, .1)'}}>
                                  <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/intergral.png" />
                                </div>
                              }
                              {
                                item.type == 3 && 
                                <div className="gifts-logo" style={{background:'rgba(253, 181, 43, .1)'}}>
                                  <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/balance.png" />
                                </div>
                              }
                              {
                                (item.type == 4 || item.type == 5) && 
                                <div className="gifts-logo" style={{background:'rgba(244, 90, 97, .1)'}}>
                                  <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/vip-card.png" />
                                </div>
                              }
                              {
                                item.type == 6 && 
                                <div className="gifts-logo" style={{background:'rgba(112, 212, 94, .1)'}}>
                                  <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/collect.png" />
                                </div>
                              }
                              {
                                item.type == 7 && 
                                <div className="gifts-logo" style={{background:'rgba(63, 145, 230, .1)'}}>
                                  <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/luckyWheel.png" />
                                </div>
                              }
                              {
                                item.type == 8 && 
                                <div className="gifts-logo" style={{background:'rgba(253, 181, 43, .1)'}}>
                                  <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/scratch.png" />
                                </div>
                              }
                              {
                                item.type == 9 && 
                                <div className="gifts-logo" style={{background:'rgba(255, 129, 45, .1)'}}>
                                  <img className="image-wrap" src="http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/golden.png" />
                                </div>
                              }
                              <div className="gifts-name">{item.title}</div>
                            </div>
                            <div className="show-btn" onClick={this.toCollectGifts} data-type={item.type} data-classify="collect">查看</div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
                <label className="ico-moon icon-closes rewardPointModal-closes" onClick={this.closeGetModal}></label>
              </div>
            </div>
          )
        }
    </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/common/reward-point-modal/RewardPointModal.jsx